import React from 'react';
import GoogleAdsAccountList from '../components/GoogleAdsAccountList';

const AccountsPage = () => {
  return <GoogleAdsAccountList />;
};

export default AccountsPage; 